import React from 'react';
import { Navigate, Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { Affix, Layout } from 'antd';
import { useAuth, useMetaContext, useTranslateContext, useUserConfigContext, useUserContext } from 'fennec-ui';
import { useDispatch, useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import SideMenu from '../../../components/SideMenu';

import { access, defaultRoute } from '../../../../common/Tool';
import FederationdministratorFederalgovernmentGeneral from '../../FederationdministratorFederalgovernmentGeneral';
import FederationadministratorFederalgovernmentCurrentmeeting from '../../FederationadministratorFederalgovernmentCurrentmeeting';
import FederationadministratorFederalgovernmentVotingcurrentmeeting from '../../FederationadministratorFederalgovernmentVotingcurrentmeeting';
import FederationadministratorEventsCalendar from '../../FederationadministratorEventsCalendar';
import FederationadministratorEventsFestivali from '../../FederationadministratorEventsFestivali';
import FederationadministratorEventsSerii from '../../FederationadministratorEventsSerii';
import FederationadministratorEventsOrders from '../../FederationadministratorEventsOrders';
import FederationadministratorEventsOrdersAll from '../../FederationadministratorEventsOrdersAll';
import FederationadministratorEventsByID from '../../FederationadministratorEventsByID';
import { BreadcrumbsProvider, MenuLevelThreeContext, MenuLevelThreeElementContext, MenuLevelTwoContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../../common/Context';
import LevelBreadcrumbs from '../../../components/LevelBreadcrumbs';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function Events(props) {
    let { id } = useParams();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const auth = useAuth();
    const t = useTranslateContext();
    const user = useUserContext();
    const meta = useMetaContext();
    const [userConfig, setUserConfig] = useUserConfigContext();
    // const langSwitch = useLangSwitchContext();

    const siteAccess = useSelector(state => state.siteAccess.value);

    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status, () => { }); // Статусы
    const notify = useSelector(state => state.home.notify, () => { }); // Уведомления

    const menu = (status, notify) => {
        const x = [
            {
                uuid: ":id",
                hidden: true,
                name: "Мероприятие",
                component: (props) => (<FederationadministratorEventsByID {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "calendar",
                default: true,
                name: "Мероприятия",
                component: (props) => (<FederationadministratorEventsCalendar {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "festivali",
                name: "Фестивали",
                component: (props) => (<FederationadministratorEventsFestivali {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "serii",
                name: "Серии",
                component: (props) => (<FederationadministratorEventsSerii {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "orders",
                name: "Заказы",
                component: (props) => (<FederationadministratorEventsOrders {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
            {
                uuid: "ordersall",
                name: "Все заказы",
                component: (props) => (<FederationadministratorEventsOrdersAll {...props} auth={auth} />),
                role: [
                    { "ID": 5, "nazvanie": "ПрезидентФедерации" },
                    { "ID": 9, "nazvanie": "АдминистраторФедерации" },
                ]
            },
        ]
        return x
    };

    return (
        <MenuLevelThreeContext.Provider value={menu(status, notify)}>
            {(!siteAccess || siteAccess == "allow") && <Routes>
                {defaultRoute(menu(status, notify), role_by_id)}
                {menu(status, notify).map((e, idx) => {
                    if (e.component && access(e, role_by_id)) {

                        return <Route key={e.uuid} path={(e.uuid !== "*")?e.uuid + "/*":"*"} element={
                            <BreadcrumbsProvider value={{
                                // parent: props?.level,
                                uuid: e?.uuid,
                                name: e?.name,
                                color: e?.color,
                                role: e?.role,
                                hidden: e.hidden
                            }}>
                                {e.component({})}
                            </BreadcrumbsProvider>} />

                    }
                })}
            </Routes>}
        </MenuLevelThreeContext.Provider>
    );
}
